import { DocketItem } from '@oolio-group/domain';

export function consolidateOrderItems(items: DocketItem[]) {
  const consolidatedItems: Record<string, DocketItem> = {};

  items.forEach(item => {
    const name = item.product?.id || item.product?.name || '';
    const notes = item.notes || '';
    const courseData = item.course?.id || '';
    const variations = item.variant?.id || item.variant?.name || '';
    const seatNumber = item?.seatNumber?.toString();
    const itemStatus = item.itemStatus || '';
    // A present parentCombo must never fall back to the empty-string key used
    // by standalone items - even with a missing id, it should stay isolated.
    // Falling back to orderItemId/id (unique per docket item) rather than a
    // shared constant, so two distinct id-less combos never collide either.
    const parentComboId = item.parentCombo
      ? item.parentCombo.id ||
        item.parentCombo.name ||
        item.orderItemId ||
        item.id ||
        'unidentified-parent-combo'
      : '';
    const sortedModifiers = (item.modifiers || [])
      .map(mod => `${mod.id}:${mod.quantity}`)
      .sort()
      .join(',');
    const comboItemsKey = (item.comboItems || [])
      .map(comboItem => {
        const comboProductId = comboItem.product?.id || '';
        const comboQuantity = comboItem.quantity || 1;
        const comboModifiers = (comboItem.modifiers || [])
          .map(mod => `${mod.id}:${mod.quantity}`)
          .sort()
          .join(',');
        const comboProductNotes = comboItem.notes || '';
        const comboVariant =
          comboItem.variant?.id || comboItem.variant?.name || '';
        const comboCourse = comboItem.course?.id || '';
        const comboOptionValues = (comboItem.optionValues || [])
          .map(opt => `${opt.id}`)
          .sort()
          .join(',');
        return `${comboProductId}:${comboQuantity}:${comboModifiers}:${comboProductNotes}:${comboVariant}:${comboCourse}:${comboOptionValues}`;
      })
      .sort()
      .join(';');
    const key = `${name}|${notes}|${courseData}|${sortedModifiers}|${variations}|${seatNumber}|${itemStatus}|${comboItemsKey}|${parentComboId}`;

    if (consolidatedItems[key]) {
      if (!consolidatedItems[key].quantity) {
        consolidatedItems[key].quantity = 0;
      }
      consolidatedItems[key].quantity =
        (consolidatedItems[key].quantity || 0) + (item.quantity || 0);

      const existing = consolidatedItems[key];

      if (!existing.consolidatedOrderItemIds) {
        existing.consolidatedOrderItemIds = [];

        if (existing.orderItemId) {
          existing.consolidatedOrderItemIds.push(existing.orderItemId);
        }
      }

      if (
        item.orderItemId &&
        !consolidatedItems[key]?.consolidatedOrderItemIds?.includes(
          item.orderItemId,
        )
      ) {
        consolidatedItems[key]!.consolidatedOrderItemIds!.push(
          item.orderItemId,
        );
      }
    } else {
      const consolidatedOrderItemIds = item.orderItemId
        ? [item.orderItemId]
        : [];

      consolidatedItems[key] = {
        ...item,
        consolidatedOrderItemIds,
      };
    }
  });

  return Object.values(consolidatedItems);
}
